// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"168":"641aef44","268":"66299c94","303":"d1de6d35","365":"dc3e03df","394":"b53556d0","660":"9b04d3d4","705":"daec8f69","745":"bf2d8902","869":"364ce240","956":"1d1d8708","979":"fe3deab3"}[chunkId] + ".js";
};